import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import { ApolloProvider } from 'react-apollo'
import { client } from 'configs/ApolloConfig'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'

import { injectGlobal } from 'styled-components'
import PangramRegular from 'fonts/Pangram-Regular.otf'
import PangramBold from 'fonts/Pangram-Bold.otf'
import PangramExtraBold from 'fonts/Pangram-ExtraBold.otf'
import PangramExtraLight from 'fonts/Pangram-ExtraLight.otf'
import PangramLight from 'fonts/Pangram-Light.otf'
import PangramMedium from 'fonts/Pangram-Medium.otf'
import PangramBlack from 'fonts/Pangram-Black.otf'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00BC70',
    },
    secondary: {
      main: '#636569',
      contracstText: '#BBB',
    },
  },
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </ApolloProvider>,
  document.getElementById('root')
)

injectGlobal`
  :root {
    --novo-green: #00BC70;
    --novo-dark-gray: #636569;
    --novo-light-gray: #BBB;
    --white: #fff;

    --space-eighth: 2px;
    --space-quarter: 4px;
    --space-half: 8px;
    --space-one: 16px;
    --space-one-and-half: 24px;
    --space-two: 32px;
    --space-three: 48px;
    --space-four: 64px;

  }

  @font-face {
    font-family: 'Pangram Regular';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Regular'), url(${PangramRegular});
  }
  @font-face {
    font-family: 'Pangram Bold';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Bold'), url(${PangramBold});
  }
  @font-face {
    font-family: 'Pangram Extra Bold';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Extra Bold'), url(${PangramExtraBold});
  }
  @font-face {
    font-family: 'Pangram Extra Light';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Extra Light'), url(${PangramExtraLight});
  }
  @font-face {
    font-family: 'Pangram Light';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Light'), url(${PangramLight});
  }
  @font-face {
    font-family: 'Pangram Medium';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Medium'), url(${PangramMedium});
  }
  @font-face {
    font-family: 'Pangram Black';
    font-style: normal;
    font-weight: normal;
    src: local('Pangram Black'), url(${PangramBlack});
  }

  * {
    box-sizing: border-box;
  }
  
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus
  input:-webkit-autofill, 
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: none;
    -webkit-text-fill-color: white;
    transition: background-color 5000s ease-in-out 0s;
  }
  -webkit-overflow-scrolling: touch;

  html {
    margin: 0;
    min-height: 100%;
    width: 100%;
  }

  body {
    display: flex;
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: 'Pangram Regular', 'Open Sans', sans-serif;
  }

  input[type="text"],
  input[type="email"],
  textarea {
    font-size: inherit;
  }

  #root {
   width: 100%;
 }
`



// WEBPACK FOOTER //
// ./src/index.js